import React, { useState, useEffect } from "react";

import "../../style/SideAds.css";

export default function SideAds() {
  const [isLargeScreen, setIsLargeScreen] = useState(true);

  useEffect(() => {
    const checkScreen = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  if (!isLargeScreen) return null;

  return <div className="col-1 side-add-main-container"></div>;
}
